import { get, has } from 'lodash'

import { isUserPermitted } from 'common/user-system-permissions-helper'

export const USER_TYPES = {
  network: 'network',
  counselor: 'counselor',
  teacher: 'teacher',
  unassociatedUser: 'unassociatedUser',
} as const

const determineUserType = (user: { Permissions: string[] }) => {
  const { network, teacher, counselor, unassociatedUser } = USER_TYPES
  const permissions = get(user, 'Permissions', [])
  if (isUserPermitted(permissions, 'BE_A_NETWORK_USER')) {
    return network
  }
  if (isUserPermitted(permissions, 'BE_A_COUNSELOR')) {
    return has(user, 'HighSchoolId') ? counselor : unassociatedUser
  }
  if (isUserPermitted(permissions, 'BE_A_TEACHER')) {
    return teacher
  }
  return unassociatedUser
}

export default determineUserType
